/**
 * The mark a loading control draws in place of its leading icon. Decorative: the control says it
 * is busy with `aria-busy`, and its label stays.
 *
 * Under reduced motion it stops turning and fades instead.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/motion.stylex";
import { motion } from "@lattice/tokens/motion.stylex";
import "@lattice/tokens/breakpoints.stylex";
import { breakpoints } from "@lattice/tokens/breakpoints.stylex";
const turn = "x1wc8ddo-B";
const fade = "xb11x9y-B";
export function Spinner() {
  return <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false" className="x1lliihq x2lah0s xh8yej3 x5yr21d x1aerksh xjrfo49 xof6966 xvp169g x1esw782 x14k9hbl xa4qsjk x1s0aqod xk95jyh">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeOpacity={0.3} strokeWidth={2} vectorEffect="non-scaling-stroke" />
      <path d="M17 10a7 7 0 00-7-7" stroke="currentColor" strokeWidth={2} strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>;
}